import {
  createAction,
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { ICreateOrganizationModalState } from './interfaces';
import { postRequest } from 'api/requests';
import { IOrganization } from 'interfaces/main';
import { defaultOrganization } from 'consts/default';

// Открытие окна с новой организацией
export const openCreateOrganizationModal = createAction(
  'createOrganizationModal/openCreateOrganizationModal',
);

// Закрытие окна с новой организацией
export const closeModal = createAction('createOrganizationModal/closeModal');

// Добавление новой группы
export const createOrganization = createAsyncThunk(
  'createOrganizationModal/createOrganization',
  async (newOrganization: IOrganization, { rejectWithValue }) => {
    try {
      const response = await postRequest('organization', newOrganization, true);

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const initialState: ICreateOrganizationModalState = {
  data: defaultOrganization,
  isLoading: false,
  isVisible: false,
};

const createOrganizationModalSlice = createSlice({
  name: 'createOrganizationModal',
  initialState,
  reducers: {
    openCreateOrganizationModal: (_, { payload }) => ({
      ...initialState,
      isVisible: true,
    }),
    closeModal: () => initialState,
    changeField: (state, { payload }) => ({
      ...state,
      data: {
        ...state.data,
        [payload.field]: payload.value,
      },
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrganization.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(createOrganization.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(createOrganization.fulfilled, () => initialState);
  },
});

// Селекторы
export const CreateOrganizationModalSelector = (
  state: RootState,
): ICreateOrganizationModalState => state.createOrganizationModal;

export const CreateOrganizationModalLoadingSelector = createSelector(
  CreateOrganizationModalSelector,
  ({ isLoading }) => isLoading,
);

export const CreateOrganizationModalVisibleSelector = createSelector(
  CreateOrganizationModalSelector,
  ({ isVisible }) => isVisible,
);

export const CreateOrganizationModalDataSelector = createSelector(
  CreateOrganizationModalSelector,
  ({ data }) => data,
);

export default createOrganizationModalSlice.reducer;
